import type { Dispatch } from '@reduxjs/toolkit';
import type { SceneJsonDto } from '@seddi/scene';
import type { SceneDesc } from '@seddi/ui-three-viewer';
import { produce } from 'immer';

import { setScene, updateScene, setStyleRegions } from '../store/appSlice';
import { importScene } from '../viewer/importScene';
import type { StyleAggregatorData } from '../api/styleAggregator';

// Base scene (without logos) — set on style load, read by AppViewer to init viewerScene.
let baseSceneInternal: SceneDesc | null = null;

export const getBaseScene = () => baseSceneInternal;
export const setBaseScene = (scene: SceneDesc | null) => {
  baseSceneInternal = scene;
};

export const setSceneFromJson = async (dispatch: Dispatch, sceneDto: SceneJsonDto) => {
  const scene = await importScene(sceneDto);
  setScene(scene);
  dispatch(updateScene());
};

export const setSceneFromStyleAggregatorData = async (
  dispatch: Dispatch,
  data: StyleAggregatorData,
  hideTearAwayLabel: boolean,
) => {
  let scene = await importScene(data.scene);

  if (hideTearAwayLabel) {
    scene = produce(scene, draft => {
      draft.children.forEach(child => {
        if (child.components?.garmentPiece?.logos) {
          child.components.garmentPiece.logos = child.components.garmentPiece.logos.filter(
            logo => !logo.isTearAwayLabel,
          );
        }
      });
    });
  }

  // Store the base scene (without logos) for the viewer to compose with logos.
  setBaseScene(scene);

  // Set scene immediately so Viewer can mount before waitForSceneReady (which needs viewerRef).
  // AppViewer.hooks will recompose with logos when sceneIsLoading becomes false.
  setScene(scene);
  dispatch(updateScene());

  // Store styleRegions in Redux; logos are set by the page. AppViewer composes the scene via viewerScene.
  dispatch(setStyleRegions(data.styleRegions));
};
